import { useMutation, UseMutationResult } from "react-query"
import { errorAlert, loadingAlert, successAlert } from "../../../utils/alert"
import { localConfig } from "../../../Configs/localConfig"
import { api } from "../../api"

interface PropsPostComando {
  usuarios: number[]
  descricao: string
  comando: string
  tipo: number
  refetch_comando: Function
}

interface PropsPostComandoEditar {
  descricao: string
  refetch_comando: Function
}

export const usePostComando = (): {
  carregando_salvar_comando: boolean
  mutate_comando: (params: PropsPostComando) => void
  isSuccess_comando: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostComando> = useMutation(
    async (params: PropsPostComando) => {
      const {
       usuarios,
       descricao,
       comando,
       tipo,
       refetch_comando
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`/adm/comando-app?codConta=${localConfig()?.conta}`,{
          usuarios,
          descricao,
          comando,
          tipo
        })
        .then((response: any) => {
          successAlert('Comando cadastrado com sucesso!', 5000, 'loading')
          refetch_comando()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
       
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar comando!', 5000, 'loading')
            })
          } else {
         
            errorAlert(
              error.response.data.error ?? 'Falha ao salvar comando!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_comando: mutation.isLoading,
    mutate_comando: mutation.mutate,
    isSuccess_comando: mutation.isSuccess,
  }
}

export const usePostComandoEditar = (cod: number): {
  carregando_salvar_comando_editar: boolean
  mutate_comando_editar: (params: PropsPostComandoEditar) => void
  isSuccess_comando: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostComandoEditar> = useMutation(
    async (params: PropsPostComandoEditar) => {
      const {
       descricao,
       refetch_comando
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .put(`/adm/comando-app/${cod}`,{
          descricao,
        })
        .then((response: any) => {
          successAlert('Comando cadastrado com sucesso!', 5000, 'loading')
          refetch_comando()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
       
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar comando!', 5000, 'loading')
            })
          } else {
         
            errorAlert(
              error.response.data.error ?? 'Falha ao salvar comando!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_comando_editar: mutation.isLoading,
    mutate_comando_editar: mutation.mutate,
    isSuccess_comando: mutation.isSuccess,
  }
}